import { JSX } from "react";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

interface ModalWindowProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    titleValue: string;
    bodyValue: string;
}

export default function ModalWindow({ titleValue, bodyValue, isOpen, setIsOpen}: ModalWindowProps): JSX.Element {
    return (
        <Modal show={isOpen} onHide={() => setIsOpen(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{ titleValue }</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p>{ bodyValue }</p>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={() => setIsOpen(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}